import React from "react";

import {useUserDevice} from "@pg-mono/user-device";
import {IInteractiveRegion, IInteractiveRegionInput, InteractiveRegionsMapAdapter} from "@pg-rp/interactive-regions-map";

import {useLazyGetMapRegionsQuery} from "../../../regions/api/get_map_region";
import {useLazyGetMapRegionDistrictsAndSurroundingsQuery} from "../../../regions/api/get_map_region_districts_and_surroundings";
import {GetListMapRegionItemDto} from "../../../regions/types/GetListMapRegionItemDto";

export interface HomeMatchUserPreferencesRegionMapProps {
    mapHeight?: number;
    updateRegionsImmediately?: boolean;
    showMainRegionMapOutline?: boolean;
    selectedRegions: IInteractiveRegionInput[] | null;
    handleUpdateRegions: (selectedRegions: IInteractiveRegion[], parentRegion: {id: number; name: string; slug: string} | null) => void;
}

export const HomeMatchUserPreferencesRegionMap: React.FC<HomeMatchUserPreferencesRegionMapProps> = (props) => {
    const {isMobile} = useUserDevice();

    const [getMainRegionLazy] = useLazyGetMapRegionsQuery();
    const [getDistrictsAndSurroundingsLazy] = useLazyGetMapRegionDistrictsAndSurroundingsQuery();

    const getMainRegion = (parentId: number) => {
        return getMainRegionLazy({region: parentId}, true)
            .unwrap()
            .then((response: {results: GetListMapRegionItemDto[]}) => response?.results?.[0] || null);
    };

    const getDistrictsAndSurroundings = (parentId: number) => {
        return getDistrictsAndSurroundingsLazy({parent: parentId}, true)
            .unwrap()
            .then((response: {results: GetListMapRegionItemDto[]}) => response?.results || null);
    };

    if (!props.selectedRegions?.length) {
        return null;
    }

    return (
        <InteractiveRegionsMapAdapter
            {...props}
            isInModal={!!isMobile}
            getMainRegion={getMainRegion}
            getDistrictsAndSurroundings={getDistrictsAndSurroundings}
            mapHeight={props.mapHeight ?? 550}
            mapHeightMobile={props.mapHeight}
            bottomControlsSlot={false}
        />
    );
};
import React from "react";

import {useUserDevice} from "@pg-mono/user-device";
import {IInteractiveRegion, IInteractiveRegionInput, InteractiveRegionsMapAdapter} from "@pg-rp/interactive-regions-map";

import {useLazyGetMapRegionsQuery} from "../../../regions/api/get_map_region";
import {useLazyGetMapRegionDistrictsAndSurroundingsQuery} from "../../../regions/api/get_map_region_districts_and_surroundings";
import {GetListMapRegionItemDto} from "../../../regions/types/GetListMapRegionItemDto";

export interface HomeMatchUserPreferencesRegionMapProps {
    mapHeight?: number;
    updateRegionsImmediately?: boolean;
    showMainRegionMapOutline?: boolean;
    selectedRegions: IInteractiveRegionInput[] | null;
    handleUpdateRegions: (selectedRegions: IInteractiveRegion[], parentRegion: {id: number; name: string; slug: string} | null) => void;
}

export const HomeMatchUserPreferencesRegionMap: React.FC<HomeMatchUserPreferencesRegionMapProps> = (props) => {
    const {isMobile} = useUserDevice();

    const [getMainRegionLazy] = useLazyGetMapRegionsQuery();
    const [getDistrictsAndSurroundingsLazy] = useLazyGetMapRegionDistrictsAndSurroundingsQuery();

    const getMainRegion = (parentId: number) => {
        return getMainRegionLazy({region: parentId}, true)
            .unwrap()
            .then((response: {results: GetListMapRegionItemDto[]}) => response?.results?.[0] || null);
    };

    const getDistrictsAndSurroundings = (parentId: number) => {
        return getDistrictsAndSurroundingsLazy({parent: parentId}, true)
            .unwrap()
            .then((response: {results: GetListMapRegionItemDto[]}) => response?.results || null);
    };

    if (!props.selectedRegions?.length) {
        return null;
    }

    return (
        <InteractiveRegionsMapAdapter
            {...props}
            isInModal={!!isMobile}
            getMainRegion={getMainRegion}
            getDistrictsAndSurroundings={getDistrictsAndSurroundings}
            mapHeight={props.mapHeight ?? 550}
            mapHeightMobile={props.mapHeight}
            bottomControlsSlot={false}
        />
    );
};
